import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import { downloadExportDocumentsBatch } from "../../api/exports";
import { handleDownload } from "../../services/PDFHandler.ts";
import { useSnack } from "../../services/SnakbarProvider";

// Every document this export can currently produce, one row per document x format.
// Scope note: only Commercial Invoice + Packing List, Litografia Gil (non-AGS)
// shipments — see Backend/Services/Exports/ExportDocumentService.cs.
const DOCUMENT_OPTIONS = [
  { key: "invoice-nobank-xlsx", label: "Factura comercial (sin banco) — Excel", documentType: "CommercialInvoice", format: "xlsx", withBank: false },
  { key: "invoice-nobank-pdf", label: "Factura comercial (sin banco) — PDF", documentType: "CommercialInvoice", format: "pdf", withBank: false },
  { key: "invoice-bank-xlsx", label: "Factura comercial (con banco) — Excel", documentType: "CommercialInvoice", format: "xlsx", withBank: true },
  { key: "invoice-bank-pdf", label: "Factura comercial (con banco) — PDF", documentType: "CommercialInvoice", format: "pdf", withBank: true },
  { key: "packing-list-xlsx", label: "Packing list — Excel", documentType: "PackingList", format: "xlsx", withBank: false },
  { key: "packing-list-pdf", label: "Packing list — PDF", documentType: "PackingList", format: "pdf", withBank: false },
];

export default function ExportDocumentsModal({ props }) {
  const { id } = props;
  const { openSnack } = useSnack();
  const [selected, setSelected] = useState(() => new Set());
  const [downloading, setDownloading] = useState(false);

  const toggle = (key) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  };

  const handleDownloadZip = async () => {
    if (selected.size === 0) {
      openSnack("Selecciona al menos un documento", "warning");
      return;
    }
    setDownloading(true);
    try {
      const picks = DOCUMENT_OPTIONS.filter((opt) => selected.has(opt.key)).map((opt) => ({
        documentType: opt.documentType,
        format: opt.format,
        withBank: opt.withBank,
      }));
      const response = await downloadExportDocumentsBatch(id, picks);
      handleDownload(
        response,
        "documentos_exportacion.zip",
        "No se pudieron descargar los documentos",
        () => openSnack("No se pudieron descargar los documentos", "error")
      );
    } catch {
      openSnack("No se pudieron descargar los documentos", "error");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Box width="100%">
      <Typography variant="body2" color="text.secondary" mb={2}>
        Selecciona los documentos a incluir en el archivo ZIP.
      </Typography>
      <FormGroup>
        {DOCUMENT_OPTIONS.map((opt) => (
          <FormControlLabel
            key={opt.key}
            control={
              <Checkbox
                checked={selected.has(opt.key)}
                onChange={() => toggle(opt.key)}
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
      <Stack direction="row" justifyContent="flex-end" mt={3}>
        <Button
          variant="contained"
          startIcon={<FileDownload />}
          disabled={downloading}
          onClick={handleDownloadZip}
        >
          Descargar ZIP
        </Button>
      </Stack>
    </Box>
  );
}
